import type { ReactNode } from 'react'

type PrizeSheetSectionProps = {
  title: string
  icon?: ReactNode
  children: ReactNode
  className?: string
}

export const PrizeSheetSection = ({
  title,
  icon,
  children,
  className
}: PrizeSheetSectionProps) => (
  <section className={className}>
    <h2 className="mb-3 flex items-center gap-2 text-sm font-bold text-gray-900">
      {icon ? (
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand-surface text-primary">
          {icon}
        </span>
      ) : null}
      <span>{title}</span>
    </h2>
    {children}
  </section>
)
